import { AxiosInstance } from 'axios';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { createViewModel } from 'mobx-utils/lib/create-view-model';
import GlobalStore from './GlobalStore';
import CurricularReportModel from '../Models/CurricularReportModel';

export default class ReflectionsReportStore {
    constructor(globalStore: GlobalStore) {
        this.axios = globalStore.axios;

        makeObservable(this, {
            experienceTypes: observable,
            initialised: observable,
            selectedExperienceTypeIds: observable,
            selectedExperienceIds: observable,
            selectedExperienceTypes: computed,
            selectedExperiences: computed,
            selectExperienceType: action,
            selectExperience: action,
            selectAll: action
        });
    }

    axios: AxiosInstance;

    experienceTypes?: CurricularReportModel[];

    selectedExperienceTypeIds: number[] = [];

    selectedExperienceIds: number[] = [];

    initialised = false;

    get selectedExperienceTypes() {
        return this.experienceTypes?.filter(e => this.selectedExperienceTypeIds.includes(e.id));
    }

    get selectedExperiences() {
        return this.experienceTypes?.slice()?.map(e => {
            const copy = createViewModel(e);
            copy.experiences = copy.experiences.filter(ex => this.selectedExperienceIds.includes(ex.id)) ?? [];
            return copy;
        })?.filter(e => e.experiences.length > 0);
    }

    selectExperienceType = (id: number) => {
        if (this.selectedExperienceTypeIds.includes(id)) {
            this.selectedExperienceTypeIds = this.selectedExperienceTypeIds.filter(x => x !== id);
        } else {
            this.selectedExperienceTypeIds.push(id);
        }
        const experiences = this.experienceTypes?.find(e => e.id === id)?.experiences;
        experiences?.forEach(experience => this.selectExperience(experience.id, this.selectedExperienceTypeIds.includes(id)));
    };

    selectExperience = (id: number, selected?: boolean, parent?: number) => {
        if (this.selectedExperienceIds.includes(id) || selected === false) {
            this.selectedExperienceIds = this.selectedExperienceIds.filter(x => x !== id);
        } else {
            this.selectedExperienceIds.push(id);
        }
        if (parent !== undefined) {
            this.selectParent(parent);
        }
    };

    selectParent = (parent: number) => {
        let toggle = false;
        const experienceType = this.experienceTypes?.find(e => e.id === parent);
        experienceType?.experiences.forEach(experience => {
            if (this.selectedExperienceIds.find(ex => ex === experience.id)) { toggle = true; }
        });
        if (!toggle) { this.selectExperienceType(parent); }
    };

    selectAll = () => {
        if (this.selectedExperienceTypeIds.length !== (this.experienceTypes?.length ?? 0)) {
            this.selectedExperienceTypeIds = this.experienceTypes?.map(e => e.id) ?? [];
            this.selectedExperienceIds = this.experienceTypes?.flatMap(e => e.experiences).map(ex => ex.id) ?? [];
        } else {
            this.selectedExperienceTypeIds = [];
            this.selectedExperienceIds = [];
        }
    };

    initialiseAsync = async () => {
        if (this.initialised) {
            return;
        }
        runInAction(() => {
            this.initialised = true;
        });
        const experience = await this.axios.get<CurricularReportModel[]>('/api/curricular');
        runInAction(() => {
            this.experienceTypes = experience.data;
            // add experience type name to experience property
            this.experienceTypes.flatMap(et => et.experiences.forEach(e => { e.typeName = et.typeName; }));
        });
        this.selectAll();
    };
}
